var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"label":"","close":_vm.canRemove},on:{"input":_vm.remove}},[_c('strong',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.description)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }